"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 * Export `slykEndpoints`.
 */
var _default = {
  confirmEmail: '/widget/confirm-email',
  joinPayspaceBySms: '/widget/sms/join-payspace',
  payspace: '/widget/domains/${slug}',
  payspaceExists: '/widget/domains/${slug}/validate',
  recoverPassword: '/widget/forgot-password',
  resetPassword: '/widget/reset-password',
  signup: '/domains/signup',
  updateAccount: '/widget/users',
  uploadFile: '/widget/presign-url'
};
exports["default"] = _default;